// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageEditor_image__tqEFe"};